import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import LandingPage from './pages/LandingPage'
import EditorPage from './pages/EditorPage'
import DashboardPage from './pages/DashboardPage'
import SettingsPage from './pages/SettingsPage'
import AdminPage from './pages/AdminPage'
import PrivacyPage from './pages/PrivacyPage'
import NewsletterPage from './pages/NewsletterPage'
import NewsletterViewPage from './pages/NewsletterViewPage'
import AgentPage from './pages/AgentPage'
import UseCasePage from './pages/UseCasePage'
import SignIn from './components/auth/SignIn'
import SignUp from './components/auth/SignUp'
import ForgotPassword from './components/auth/ForgotPassword'
import AuthCallback from './components/auth/AuthCallback'
import ProtectedRoute from './components/auth/ProtectedRoute'
import { trackPageView } from './utils/visitorAnalytics'

function App() {
    const location = useLocation()

    // Track page views on route changes
    useEffect(() => {
        trackPageView()
    }, [location.pathname])

    return (
        <div className="min-h-screen bg-slate-950">
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/agent" element={<AgentPage />} />
                <Route path="/use-case/:slug" element={<UseCasePage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/newsletter" element={<NewsletterPage />} />
                <Route path="/newsletter/:id" element={<NewsletterViewPage />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/auth/callback" element={<AuthCallback />} />

                {/* Protected Routes */}
                <Route path="/app" element={
                    <ProtectedRoute>
                        <EditorPage />
                    </ProtectedRoute>
                } />
                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <DashboardPage />
                    </ProtectedRoute>
                } />
                <Route path="/settings" element={
                    <ProtectedRoute>
                        <SettingsPage />
                    </ProtectedRoute>
                } />
                <Route path="/admin" element={
                    <ProtectedRoute>
                        <AdminPage />
                    </ProtectedRoute>
                } />
            </Routes>
            <Analytics />
        </div>
    )
}

export default App
